import type { VariantProps } from 'class-variance-authority'
import { cva } from 'class-variance-authority'

export { default as Button } from './Button.vue'

export const buttonVariants = cva(
  'inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md text-sm font-medium ring-offset-background transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 [&_svg]:pointer-events-none [&_svg]:size-4 [&_svg]:shrink-0',
  {
    variants: {
      variant: {
        // ─── Core semantic variants (use CSS design-token colours) ───────────
        default:
          'bg-primary text-primary-foreground shadow-sm hover:bg-primary/85 active:bg-primary/95',
        destructive:
          'bg-destructive text-destructive-foreground shadow-sm hover:bg-destructive/85 active:bg-destructive/95 dark:bg-destructive/80 dark:hover:bg-destructive/70',
        outline:
          'border border-input bg-background text-foreground shadow-sm hover:bg-muted hover:text-foreground active:bg-muted/80',
        secondary:
          'border border-border bg-secondary text-foreground shadow-sm hover:bg-muted active:bg-muted/80',
        ghost: 'text-foreground hover:bg-muted hover:text-foreground active:bg-muted/80',
        link: 'text-primary underline-offset-4 hover:underline hover:text-primary/80',

        // ─── Contextual status variants (semantic design tokens) ─────────────
        success:
          'bg-success text-success-foreground shadow-sm hover:bg-success/90 active:bg-success/95 focus-visible:ring-success',
        warning:
          'bg-warning text-white shadow-sm hover:bg-warning/90 active:bg-warning/95 focus-visible:ring-warning',
        info: 'bg-info text-info-foreground shadow-sm hover:bg-info/90 active:bg-info/95 focus-visible:ring-info'
      },
      size: {
        default: 'h-10 px-4 py-2',
        sm: 'h-9 rounded-md px-3',
        lg: 'h-11 rounded-md px-8',
        icon: 'h-10 w-10',
        'icon-sm': 'size-9',
        'icon-lg': 'size-11'
      }
    },
    defaultVariants: {
      variant: 'default',
      size: 'default'
    }
  }
)

export type ButtonVariants = VariantProps<typeof buttonVariants>
